import { createContext } from 'react';
import initialGeneralState from './initialGeneralState';

const GeneralContext = createContext(initialGeneralState);

export default GeneralContext;
